
<script>
import { nToWord } from '@/utils/helpers'

export default {
  name: 'rex-rounded-multi-select',
  props: {
    label: {
      type: String,
      default: () => null
    },
    data: {
      type: Array,
      default: () => []
    },
    storeModule: {
      type: String,
      default: () => null,
      required: true
    },
    getterName: {
      type: String,
      default: () => null,
      required: true
    },
    setterName: {
      type: String,
      default: () => null,
      required: true
    },
    target: {
      type: String,
      default: () => null,
      required: true
    },
    cssAbsolute: {
      type: Boolean,
      default: () => false
    },
    cssClass: {
      type: String,
      default: () => null
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    showLabel: {
      type: Boolean,
      default: () => true
    },
    hideIfEmpty: {
      type: Boolean,
      default: () => true
    },
    emptyText: {
      type: String,
      default: () => 'Любое'
    },
    hasCustomIcon: {
      type: Boolean,
      default: () => false
    }
  },
  data: () => ({
    showList: false
  }),
  computed: {
    value: {
      get() {
        return this.$store.getters[`${this.storeModule}/${this.getterName}`](this.target)
      },
      set(value) {
        this.$store.commit(`${this.storeModule}/${this.setterName}`, {
          target: this.target,
          value
        })

        this.$emit('onChange', {
          event: value,
          element: this.$vnode.elm
        })
      }
    },
    selectInfo() {
      const currentSelectValues = this.data.map(x => x.slug)
      const valueLength = this.value.filter(x => currentSelectValues.includes(x)).length

      return valueLength === 0 ? this.emptyText : `${valueLength} ${nToWord(valueLength, ['вариант', 'варианта', 'вариантов'])}`
    },
    showField() {
      return this.hideIfEmpty ? this.data.length > 0 : true
    },
    isDisabled() {
      return this.disabled || (this.data.length === 0 && !this.hideIfEmpty)
    }
  }
}
</script>

<template>
  <div
    v-if="showField"
    :class="cssClass"
    class="rex-rounded-field"
  >
    <h3
      v-if="showLabel"
      class="rex-rounded-field--label"
    >
      {{ label }}
    </h3>
    <div
      :class="{ active: showList}"
      class="rex-rounded-multiselect"
    >
      <b-dropdown
        v-model="value"
        :multiple="true"
      >
        <div
          slot="trigger"
          :class="{ disabled: isDisabled }"
          class="rex-rounded-multiselect--header"
        >
          <p>{{ selectInfo }}</p>
          <slot
            v-if="hasCustomIcon"
          />
          <b-icon
            v-else
            icon="chevron-down"
            custom-size="mdi-24px"
            class="rex-rounded-multiselect--custom-icon-down"
          />
        </div>
        <b-dropdown-item
          v-for="item in data"
          :key="item.slug"
          :value="item.slug"
        >
          {{ item.name }}
        </b-dropdown-item>
      </b-dropdown>
    </div>
  </div>
</template>
